import { render } from "./MainSlide.vue?vue&type=template&id=5c7baa5b&scoped=true"
import script from "./MainSlide.vue?vue&type=script&lang=js"
export * from "./MainSlide.vue?vue&type=script&lang=js"

import "./MainSlide.vue?vue&type=style&index=0&id=5c7baa5b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c7baa5b"]])

export default __exports__